import React from 'react';
import { makeStyles } from 'housecall-ui';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

type Props = {
  value: number;
  maxValue: number;
  round?: boolean;
};

type StyleProps = {
  percent: number;
  round: boolean;
};

const borderRadiusProperty = ({ round }: StyleProps) => (round ? '24px' : '0px');

const useStyles = makeStyles((theme: HCPTheme) => ({
  bar: {
    outline: `1px solid ${theme.palette.secondary[300]}`,
    outlineOffset: '-1px',
    backgroundColor: theme.palette.white.primary,
    width: '100%',
    borderRadius: borderRadiusProperty,
    position: 'relative',
    height: '12px',
    overflow: 'hidden',
  },
  progress: {
    position: 'absolute',
    top: '0',
    left: '0',
    height: '100%',
    borderRadius: borderRadiusProperty,
    width: '100%',
    backgroundColor: theme.palette.success.main,
    transition: 'transform .5s',
    transform: ({ percent }: StyleProps) => `translateX(-${100 - percent}%)`,
  },
}));

export const ProgressBar = ({ value, maxValue, round = true }: Props) => {
  const percentProgress = (value / maxValue) * 100;
  const { bar, progress } = useStyles({ percent: percentProgress, round });

  return (
    <div className={bar}>
      <div data-testid="progress-bar-fill" className={progress} />
    </div>
  );
};
